const join = (base, p) => `${base.replace(/\/$/, '')}/${p.replace(/^\//, '')}`;

export function makeApi(boot) {
  const headers = { 'X-WP-Nonce': boot.nonce };
  const root = boot.restRoot;

  return {
    upload(file, sessionToken, onProgress) {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('product_id', String(boot.productId));
      if (sessionToken) fd.append('session_token', sessionToken);

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', join(root, 'upload'));
        Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));
        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable && onProgress) onProgress({ stage: 'uploading', value: e.loaded / e.total });
        };
        xhr.upload.onload = () => {
          // Body fully sent — server is now analyzing.
          if (onProgress) onProgress({ stage: 'analyzing', value: 1 });
        };
        xhr.onload = () => {
          try { resolve(JSON.parse(xhr.responseText)); }
          catch { reject(new Error('Bad JSON from /upload')); }
        };
        xhr.onerror = () => reject(new Error('Network error'));
        xhr.send(fd);
      });
    },

    async quote(sessionToken, quantities) {
      const res = await fetch(join(root, 'quote'), {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: boot.productId, session_token: sessionToken, quantities }),
      });
      return res.json();
    },

    async remove(sessionToken, fileId) {
      const res = await fetch(join(root, 'remove'), {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_token: sessionToken, file_id: fileId }),
      });
      return res.json();
    },

    async addToCart(sessionToken, acknowledgements) {
      const res = await fetch(join(root, 'add-to-cart'), {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: boot.productId, session_token: sessionToken, acknowledgements }),
      });
      return res.json();
    },
  };
}
